import {
    api,
    urls
} from '../../../_common/scripts/api';
import functions from '../../../_common/scripts/functions';
import validator from "../../../_common/scripts/validator";
import helpers from "../../../_common/scripts/helpers";
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';
import datepickerESFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-es';
import moment from "moment";
import Modal from "../../../_common/scripts/modal";


let models, provinces, dealers, modal, sendButton, vehicles, vehicle;

var userInteractionStarted = false;

const analyticsMap = {
    "default": {
        "pageInfo": {
            "brand": "chevrolet",
            "country": "argentina",
            "languageSelected": "spanish",
            "pageName": "ch:SA:AR:es:t1:2020-pda-home:pda-online-appointment",
            "pageType": "forms",
            "region": "south america"
        }
    },
    "cruze": {
        "pageInfo": {
            "brand": "chevrolet",
            "pageType": "forms",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-cruze-5p",
            "languageSelected": "spanish",
            "country": "argentina",
            "region": "south america"
        },
        "vehicleInfo": {
            "modelName": "cruze",
            "bodyStyle": "cruze 5",
            "vehicleType": "car",
            "modelYear": "2020"
        }
    },
    "joy": {
        "pageInfo": {
            "brand": "chevrolet",
            "pageType": "forms",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-joy",
            "languageSelected": "spanish",
            "country": "argentina",
            "region": "south america"
        },
        "vehicleInfo": {
            "modelName": "joy",
            "bodyStyle": "joy hb",
            "vehicleType": "car",
            "modelYear": "2020"
        }
    },
    "joy-plus": {
        "pageInfo": {
            "brand": "chevrolet",
            "pageType": "forms",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-joy-plus",
            "languageSelected": "spanish",
            "country": "argentina",
            "region": "south america"
        },
        "vehicleInfo": {
            "modelName": "joy",
            "bodyStyle": "joy plus",
            "vehicleType": "car",
            "modelYear": "2020"
        }
    },
    "onix": {
        "pageInfo": {
            "brand": "chevrolet",
            "pageType": "forms",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-onix",
            "languageSelected": "spanish",
            "country": "argentina",
            "region": "south america"
        },
        "vehicleInfo": {
            "modelName": "onix",
            "bodyStyle": "onix hatchback",
            "vehicleType": "car",
            "modelYear": "2020"
        }
    },
    "s10-4x2-ls": {
        "pageInfo": {
            "brand": "chevrolet",
            "pageType": "forms",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-s10",
            "languageSelected": "spanish",
            "country": "argentina",
            "region": "south america"
        },
        "vehicleInfo": {
            "modelName": "s10",
            "bodyStyle": "s10 double cab",
            "vehicleType": "truck",
            "modelYear": "2020"
        }
    },
    "nueva-tracker": {
        "pageInfo": {
            "brand": "chevrolet",
            "country": "argentina",
            "languageSelected": "spanish",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-new-tracker",
            "pageType": "forms",
            "region": "south america"
        },
        "vehicleInfo": {
            "bodyStyle": "tracker",
            "modelName": "tracker",
            "modelYear": "2021",
            "vehicleType": "crossover"
        }
    },
    "nueva-tracker-premier": {
        "pageInfo": {
            "brand": "chevrolet",
            "country": "argentina",
            "languageSelected": "spanish",
            "pageName": "ch:sa:ar:es:t1:2020-pda-home:pda-new-tracker-premier",
            "pageType": "forms",
            "region": "south america"
        },
        "vehicleInfo": {
            "bodyStyle": "tracker premier",
            "modelName": "tracker",
            "modelYear": "2021",
            "vehicleType": "crossover"
        }
    }
};

let formName = "leadbix-form",
    form = '',
    inputs = [
        "vehicle",
        "dealer",
        "first-name",
        "last-name",
        "document-number",
        "birthday",
        "cp",
        "area",
        "phone",
        "email",
        "bases",
        "privacy"
    ],
    formType = "model";

const errorHandler = error => {
    console.log(error);
};

const populateDealers = () => {
    functions.clearElements(dealers);
    api().dealers().get(provinces.value, function(data) {
        functions.addOptions(data, dealers, "Concesionario", "bac");
    })
};

const populateProvinces = () => {
    api().provinces().getList(function(data) {
        provinces.addEventListener("change", populateDealers);
        functions.addOptions(data, provinces, "Provincia", "id");
        functions.addOptions([], dealers, "Concesionario");
    });
};

const populateVehicles = () => {
    form.classList.add('visible');
    functions.addOptions(models, vehicles, "Seleccioná Modelo", "id");

    vehicles.addEventListener('change', () => {
        if (vehicle != null) {
            vehicle.value = getSelectedText("vehicle");
        }
    });
};

const populateSingleVehicle = (model) => {
    api().models().getSingleByUrl(model, function(data) {
        addDataToForm(data, models);
    });
    document.getElementsByClassName("form-content")[0].classList.add('model');
    $(vehicles).closest('fieldset').remove();

    document.addEventListener(
        "click",
        function(event) {
            if (!event.target.classList.contains("show-form")) return;

            _satellite.track("form-start");
            userInteractionStarted

            // Prevent default link behavior
            event.preventDefault();

            // Get the content
            functions.show(formName);

            var btn = document.getElementById("btn-show-form");
            btn.style.display = "none";

            $(form).slideDown(400);
        },
        false
    );
};

$('[name="vehicle"]').bind('change', function() {
    if (!userInteractionStarted) {
        _satellite.track("form-start");
        userInteractionStarted = true;
    }
});

const addDataToForm = (model, models) => {
    document.getElementById("form-img").setAttribute("src", models.find(item => item.id == model.id).imageMobile);
    document.getElementById("form-shortname").innerHTML = model.shortName + " 0KM";
    document.getElementById("form-model").value = model.name;
};

const showSendButton = () => {

    let fieldset = document.getElementById("your-information");
    let sendBtn = document.getElementById("send");

    let contactIcon = functions.elementCreater("div", "", {
        class: "contact-icon"
    });
    let contactInfo = functions.elementCreater("span", "Contactá un agente de ventas", {
        class: "contact-info"
    });

    if (window.location.hash) {
        sendBtn.innerHTML = "";
        sendBtn.appendChild(contactIcon);
        sendBtn.appendChild(contactInfo);
        fieldset.appendChild(sendBtn);
    }
};

const init = () => {

    api().models().getList(function(data) {
        models = data;
        form = document.getElementById(formName);
        let model = decodeURI(window.location.hash.replace("#", ""));
        //formType = model == '' ? 'online-booking' : 'model';
        inputs = model == '' ? inputs : inputs.filter(item => item !== 'vehicle');

        if (model && typeof analyticsMap[model] !== 'undefined') {
            digitalData.pageInfo = analyticsMap[model].pageInfo;
            digitalData.vehicleInfo = analyticsMap[model].vehicleInfo;
        } else {
            digitalData.pageInfo = analyticsMap['default'].pageInfo;
        }

        provinces = document.getElementById("leadbix-form-provinces");
        dealers = document.getElementById("leadbix-form-dealers");
        vehicles = document.getElementById("leadbix-form-vehicles");
        vehicle = document.getElementById("form-model");

        if (provinces != null) {
            populateProvinces();
            get("document-number").setAttribute("maxlength", 8);
        }

        if (vehicles != null) {
            if (inputs.indexOf('vehicle') !== -1) {
                populateVehicles();
            } else {
                populateSingleVehicle(model);
            }
        }

        showSendButton();

        sendButton = document.getElementById("send");

        sendButton.addEventListener("click", submit);

        let numberNodes = document.getElementsByClassName("only-number");

        for (let i = 0; i < numberNodes.length; i++) {
            numberNodes[i].addEventListener("keydown", functions.allowOnlyNumbers);
            numberNodes[i].addEventListener("blur", functions.changeIfNumbers);
        }

        inputs.map(input => {
            let node = get(input);

            if ((node.length == null || node.length < 2) && !functions.hasClass(node, "is-a-date")) {
                node.addEventListener("change", () => {
                    if (validator.validateSingle(node)) customeValidations(input);
                });

                node.addEventListener("blur", () => {
                    if (validator.validateSingle(node)) customeValidations(input);
                });
            }
        });

        let dateNodes = document.getElementsByClassName("is-a-date");

        for (let i = 0; i < dateNodes.length; i++) {
            let id = dateNodes[i].getAttribute("id");

            if (id != null && id != "") {

                datepickerFactory($);
                datepickerESFactory($);

                $("#" + id).datepicker({
                    dateFormat: "dd-mm-yy",
                    maxDate: "-21y",
                    regional: "es",
                    changeYear: true,
                    yearRange: "1920:" + new Date().getFullYear(),
                    onClose: () => {
                        //console.log($("#" + id).datepicker('getDate'))
                        //$("#" + id).datepicker('setDate', $("#" + id).datepicker('getDate'));
                        if (validator.validateSingle(dateNodes[i])) customeValidations(dateNodes[i].getAttribute("name"));
                    },
                    onSelect: () => {
                        if (validator.validateSingle(dateNodes[i])) customeValidations(dateNodes[i].getAttribute("name"));
                    }
                });
            }
        }
    });

};

const getRadioValue = name => {
    let nodes = form.elements.namedItem(name);

    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].checked) {
            return nodes[i].value;
        }
    }

    return false;
};

const customeValidations = (field = "") => {
    if (field == "" || field == "first-name")
        if (get("first-name").value.length >= 50) {
            validator.error(get("first-name"), "Ingrese menos de 50 caracteres.");
            return false;
        }

    if (field == "" || field == "last-name")
        if (get("last-name").value.length >= 50) {
            validator.error(get("last-name"), "Ingrese menos de 30 caracteres.");
            return false;
        }

        // Validar el email repetido, etc
    if (formType === "model" || formType === "get-your-plan") { // || formType === "online-booking"
        const mask = /^[0-9]{7,8}$/;

        if (field == "" || field == "document-number")
            if (mask.test(get("document-number").value) !== true) {
                validator.error(get("document-number"), "Ingrese entre 7 y 8 caracteres");

                return false;
            }

        if (field == "" || field == "birthday") {
            let date = moment(get("birthday").value, "DD-MM-YYYY");
            let now = moment(new Date());
            let age = moment.duration(now.diff(date)).asYears();
            if (!moment(get("birthday").value, "DD-MM-YYYY", true).isValid()) {
                document.getElementsByName(field)[0].value = '';
                validator.error(get("birthday"), "La fecha ingresada no es correcta");
                return false;
            } else if (age < 21) {
                document.getElementsByName(field)[0].value = '';
                validator.error(get("birthday"), "Debe ser mayor de 21 años");
                return false;
            }
        }

        if (field == "" || field == "phone" || field == "area") {
            let parsed = parseInt(get("area").value);
            get("area").value = isNaN(parsed) ? "" : parsed;

            if (get("area").value.length < 2 || get("area").value.length > 4) {
                validator.error(get("area"), "Por favor introduzca entre 2 y 4 caracteres (Código de área)");

                return false;
            }

            //get("phone").setAttribute("maxlength", 10 - get("area").value.length);

            if (get("phone").value.length != 8 && get("phone").value != "") {
                validator.error(get("phone"), "Por favor introduzca 8 caracteres (Teléfono)");

                return false;
            }
        }
    }

    if (formType === "speak-with-us") {
        if (getRadioValue("customer") === "si" && (field == "" || field == "request"))
            if (get("request").value.trim().length < 6) {
                validator.error(get("request"), "Ingrese al menos de 6 caracteres.");
                return false;
            }

        if (field == "" || field == "message")
            if (get("message").value.trim().length < 10) {
                validator.error(get("message"), "Ingrese al menos de 10 caracteres.");
                return false;
            }
    }


    return true;
};

const sharedData = () => {
    return {
        firstName: get("first-name").value,
        lastName: get("last-name").value,
        email: get("email").value
    };
};

const dataModel = () => {
    let data = sharedData();

    data.province = getSelectedText("province");
    data.dealer = getSelectedText("dealer");
    data.bac = get("dealer").value;
    data.documentNumber = functions.removeNoNumbers(get("document-number").value);
    data.birthday = get("birthday").value;
    data.cp = get("cp").value;
    data.model = get("model").value;
    data.phone = functions.removeNoNumbers(get("area").value) + functions.removeNoNumbers(get("phone").value);

    return data;
};

const dataCustomer = () => {
    let data = sharedData();

    data.customer = getRadioValue("customer");

    if (data.customer === "si") {
        data.group = get("group").value;
        data.order = get("order").value;
        data.request = get("request").value.trim();
        /* data.schedule = get("schedule").value; */
        data.documentNumber = functions.removeNoNumbers(get("document-number").value);
    }

    data.subject = get("subject").value;
    data.subjectName = getSelectedText("subject");
    data.phone = functions.removeNoNumbers(get("phone").value);
    /* data.cell = functions.removeNoNumbers(get("cell").value); */
    data.message = get("message").value.trim();

    return data;
};

const submit = e => {

    const prepareData = (data, type = "model", sibel) => {
        let newData = data;
        newData.sibel = sibel.environment;
        newData.Formulario =
            type === "model" ? "Modelos" :
            type === "get-your-plan" ? "Adquirí tu plan" :
            //type === "online-booking" ? "Reserva online" :
            "Hablá con nosotros";
        newData.campaign = "PDA";

        return newData;
    };

    const send = (data, type, cb) => {
        let service = helpers();

        service.post(
            urls.sibel.api,
            prepareData(data, type, urls.sibel)
        ).then(cb);
    };

    var validation = validator.validate(form);

    if ((Object.keys(validation).length == 0 || validation === true) && customeValidations()) {
        let data = formType === "model" || formType === "get-your-plan" ? dataModel() : formType === "speak-with-us" ? dataCustomer() : false; //|| formType === "online-booking" 

        if (data !== false) {
            sendButton.setAttribute("disabled", true);

            send(data, formType, function() {
                console.log('sended')
                _satellite.track("form-complete");

                sendButton.setAttribute("disabled", true);

                let modal = new Modal("submit-modal", {
                    transition: false
                });
                modal.init();

                if (modal != null) {
                    modal.open(e);
                } else {
                    console.log('Sin modal');
                }

                //let windowReference = window.open();

                /*if (formType === "online-booking") {
                  //windowReference.location = url;
                  //window.open('https://www.mercadopago.com/mla/checkout/start?pref_id=362465091-3f442e25-baf7-48ee-a4ab-5ad2a16ae706', '_blank');
                  let url = "https://www.mercadopago.com/mla/checkout/start?pref_id=362465091-3f442e25-baf7-48ee-a4ab-5ad2a16ae706";
                  let evLink = document.createElement('a');
                  evLink.href = url;
                  evLink.target = '_blank';
                  document.body.appendChild(evLink);
                  evLink.click();
                  // Now delete it
                  evLink.parentNode.removeChild(evLink);
                }*/
            });
        }
    } else {
        var errors = [];
        $.each(validation, function(i, item) {
            errors.push(item);
        });
        if (typeof digitalData.formInfo == 'undefined') {
            digitalData.formInfo = {};
        }
        digitalData.formInfo.errorMessage = errors.join(' | ');
        _satellite.track("error-message");
    }
};

const get = (name = "") => {
    return form.elements.namedItem(name);
};

const getSelectedText = name => {
    let node = get(name);

    if (node.selectedIndex == -1) {
        return "";
    }

    return node.options[node.selectedIndex].text;
};

/*
const init = () => {
  let model = decodeURI(window.location.hash.replace("#", ""));

  if (model == '') {
    return false;
  }

  api().models().getList(function (models) {

  });
}
*/

init();